import {IUserProfile} from "../models/Auth";
import defaultProfileIcon from "../assets/images/default-profile-image.png";
import defaultVenueImage from "../assets/images/default-venue-image.png";
import defaultLogo from "../assets/images/default-logo.svg";
import {environment} from "../environment";
import {IPublicTrainer} from "../models/Trainer";

export const getProfileImage = (serverPath: string, profile: IUserProfile | null) => {
    if (!profile) return defaultProfileIcon;
    if (!profile.profileImage) return defaultProfileIcon;

    return serverPath + profile.profileImage.slice(1);
}

export const getTrainerImage = (serverPath: string, trainer: IPublicTrainer) => {
    if (!trainer) return defaultProfileIcon;
    if (!trainer.profileImage) return defaultProfileIcon;
    // console.log(serverPath + trainer.profileImage.slice(1));
    return serverPath + trainer.profileImage.slice(1);
}

export const getImageFromAuthServer = (value: string) => {
    if (value === "/public/assets/classes/no-cover.png") {
        return environment.onlineAuthenticationServer + "/public/assets/classes/no-cover.png";
    } else if (value) {
        return environment.onlineAuthenticationServer + value + "Enrolled.png";
    }
}

export const getProfileImageByString = (serverPath: string, value: string) => {
    if (!value) return defaultProfileIcon;
    if (!value) return defaultProfileIcon;

    return serverPath + value.slice(1);
}

export const getImageUrlForContent = (path: string | null) => {
    if (!path) return null;
    return path;
}

export const getVenueImage = (serverPath: string, imagePath: string | null) => {
    if (imagePath) {
        return serverPath.slice(0, serverPath.length - 1) + imagePath;
    } else {
        return defaultVenueImage;
    }
}

export const getLogo = (url: string | null) => {
    if (url) {
        return url;
    }
    return defaultLogo;
}